import './Icon_Minimize.css';
import {ReactComponent as MinimizeIcon} from './Icons_Minus_Outline_Brand.svg';
function Icon_Chevron_Right() {
  return (
    <div className='icon-container-minimize'>
     <MinimizeIcon className="minimize-svg" />
    </div>
  );
}
 
export default Icon_Chevron_Right;
 
//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-minimize2-icon lucide-minimize-2">
// <path d="m14 10 7-7"/><path d="M20 10h-6V4"/><path d="m3 21 7-7"/><path d="M4 14h6v6"/></svg>